const STORAGE_KEY = 'postLoginRedirect';

export function savePostLoginRedirect(targetPath: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, targetPath || '/');
  } catch {}
}

export function consumePostLoginRedirect(): string {
  try {
    const val = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
    return val || '/';
  } catch {
    return '/';
  }
}

export function getPostLoginRedirect(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function ensurePostLoginRedirect(defaultTarget: string): void {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (!existing) {
      localStorage.setItem(STORAGE_KEY, defaultTarget || '/');
    }
  } catch {}
}


